<div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
  <div>
    <h3 class="text-xs font-semibold uppercase tracking-wide text-dusk">
      Regular picks ({{ regularPicks().length }})
    </h3>
    @if (regularPicks().length === 0) {
      <p class="mt-2 text-sm text-dusk">None.</p>
    } @else {
      <ul class="mt-2 flex flex-col gap-2">
        @for (pick of regularPicks(); track pick.id) {
          <li class="flex items-center justify-between rounded border border-hairline px-3 py-1.5 text-sm">
            <span class="flex items-center gap-2 text-parchment">
              @if (pick.person.imageUrl) {
                <img [src]="pick.person.imageUrl" alt="" class="h-7 w-7 shrink-0 rounded-full object-cover" />
              }
              {{ pick.person.name }}
            </span>
            <span class="flex items-center gap-2">
              @if (pick.person.status === 'DEAD') {
                <span class="text-xs font-semibold text-wax-bright">Deceased</span>
              } @else {
                <span class="text-xs text-dusk">Alive</span>
              }
              @if (allowRemove()) {
                <button
                  type="button"
                  (click)="remove.emit(pick)"
                  [disabled]="removingId() === pick.id"
                  class="text-dusk hover:text-wax-bright disabled:cursor-not-allowed disabled:opacity-50"
                  [attr.aria-label]="'Remove ' + pick.person.name"
                >
                  {{ removingId() === pick.id ? '…' : '✕' }}
                </button>
              }
            </span>
          </li>
        }
      </ul>
    }
  </div>

  <div>
    <h3 class="text-xs font-semibold uppercase tracking-wide text-dusk">
      Alternates ({{ alternatePicks().length }})
    </h3>
    @if (alternatePicks().length === 0) {
      <p class="mt-2 text-sm text-dusk">None.</p>
    } @else {
      <ul class="mt-2 flex flex-col gap-2">
        @for (pick of alternatePicks(); track pick.id) {
          <li class="flex items-center justify-between rounded border border-hairline px-3 py-1.5 text-sm">
            <span class="flex items-center gap-2 text-parchment">
              @if (pick.person.imageUrl) {
                <img [src]="pick.person.imageUrl" alt="" class="h-7 w-7 shrink-0 rounded-full object-cover" />
              }
              {{ pick.person.name }}
              @if (pick.promotedAt) {
                <span class="ml-1 text-xs text-gold">(promoted)</span>
              }
            </span>
            <span class="flex items-center gap-2">
              @if (pick.person.status === 'DEAD') {
                <span class="text-xs font-semibold text-wax-bright">Deceased</span>
              } @else {
                <span class="text-xs text-dusk">Alive</span>
              }
              @if (allowRemove()) {
                <button
                  type="button"
                  (click)="remove.emit(pick)"
                  [disabled]="removingId() === pick.id"
                  class="text-dusk hover:text-wax-bright disabled:cursor-not-allowed disabled:opacity-50"
                  [attr.aria-label]="'Remove ' + pick.person.name"
                >
                  {{ removingId() === pick.id ? '…' : '✕' }}
                </button>
              }
            </span>
          </li>
        }
      </ul>
    }
  </div>
</div>
